import {Component, Inject, OnInit, Optional} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBar} from '@angular/material/snack-bar';
import {SnackBarDataInjectedInterface} from 'fuse-core/news/snackbar/snack-bar-data-injected.interface';

@Component({
    selector: 'app-avatar-page-popup',
    templateUrl: './avatar-page-popup.component.html',
    styleUrls: ['./avatar-page-popup.component.scss'],
    standalone: false
})
export class AvatarPagePopupComponent implements OnInit {

    constructor(private snackbar: MatSnackBar,
                @Optional() @Inject(MAT_SNACK_BAR_DATA) public data: SnackBarDataInjectedInterface) {
    }

    ngOnInit(): void {
    }

    public onClick(): void {
        this.snackbar.dismiss();
    }
}